/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Settings_Venues_List_CountInputs */

const cs_settings_venues_list_count = /** @type {(inputs: Settings_Venues_List_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.shown} z ${i?.total}`)
};

const en_settings_venues_list_count = /** @type {(inputs: Settings_Venues_List_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.shown} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{shown} of {total}" |
*
* @param {Settings_Venues_List_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_list_count = /** @type {((inputs: Settings_Venues_List_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_List_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_list_count(inputs)
	return cs_settings_venues_list_count(inputs)
});